function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoorders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 101.075,
    viewBox: "0 0 112 101.075",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "yxp4lq34da"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17679",
    style: {
      fill: "none"
    },
    d: "M0 0h73.628v101.075H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "No orders"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18212"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18211"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18210",
    transform: "translate(0 .001)",
    style: {
      clipPath: "url(#yxp4lq34da)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59477",
    d: "M69.558 193.251H4.07a4.07 4.07 0 0 1-4.07-4.07v-86.505a4.07 4.07 0 0 1 4.07-4.07h65.488a4.07 4.07 0 0 1 4.07 4.07v86.506a4.07 4.07 0 0 1-4.07 4.07",
    transform: "translate(0 -92.176)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17666",
    transform: "translate(4.586 12.065)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h64.456v83.374H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59478",
    d: "M431.629 4.94a5 5 0 0 0-9.991 0h-4.629v7.916h19.249V4.94zm-5 .791a1.762 1.762 0 1 1 1.771-1.763 1.762 1.762 0 0 1-1.762 1.762",
    transform: "translate(-389.819 .004)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 17667",
    width: 50.599,
    height: 4.989,
    rx: 2.494,
    transform: "translate(10.347 20.772)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 17680",
    width: 50.599,
    height: 4.989,
    rx: 2.494,
    transform: "translate(10.347 28.904)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 17681",
    width: 30.849,
    height: 4.989,
    rx: 2.494,
    transform: "translate(10.347 37.037)",
    style: {
      fill: "#f5f5f5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18209"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17650",
    transform: "translate(67.06 74.775)",
    style: {
      fill: "#8d989e"
    },
    d: "M0 0h26.189v26.3H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17651",
    transform: "translate(78.576 74.775)",
    style: {
      fill: "#1d2238"
    },
    d: "M0 0h3.157v4.164H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17652",
    transform: "translate(93.249 74.775)",
    style: {
      fill: "#b0bec5"
    },
    d: "M0 0h18.751v26.3H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17653",
    transform: "translate(101.424 74.775)",
    style: {
      fill: "#1d2238"
    },
    d: "M0 0h2.4v4.164H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17654",
    transform: "translate(62.012 24.441)",
    style: {
      fill: "#ccd6da"
    },
    d: "M0 0h26.189v50.334H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17655",
    transform: "translate(73.529 24.441)",
    style: {
      fill: "#1d2238"
    },
    d: "M0 0h3.157v7.97H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17656",
    transform: "translate(88.202 24.441)",
    style: {
      fill: "#dfe5e7"
    },
    d: "M0 0h18.751v50.334H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17657",
    transform: "translate(96.377 24.441)",
    style: {
      fill: "#1d2238"
    },
    d: "M0 0h2.4v7.97H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17658",
    transform: "translate(17.979 74.775)",
    style: {
      fill: "#ccd6da"
    },
    d: "M0 0h33.682v26.3H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17659",
    transform: "translate(32.79 74.775)",
    style: {
      fill: "#1d2238"
    },
    d: "M0 0h4.06v4.164H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17660",
    transform: "translate(51.661 74.775)",
    style: {
      fill: "#dfe5e7"
    },
    d: "M0 0h22.288v26.3H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17661",
    transform: "translate(61.431 74.775)",
    style: {
      fill: "#1d2238"
    },
    d: "M0 0h4.06v4.164H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17662",
    transform: "translate(22.119 48.474)",
    style: {
      fill: "#c7d1d6"
    },
    d: "M0 0h26.189v26.3H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17663",
    transform: "translate(33.636 48.474)",
    style: {
      fill: "#1d2238"
    },
    d: "M0 0h3.157v4.164H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17664",
    transform: "translate(48.309 48.474)",
    style: {
      fill: "#dfe5e7"
    },
    d: "M0 0h18.751v26.3H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17665",
    transform: "translate(56.484 48.474)",
    style: {
      fill: "#1d2238"
    },
    d: "M0 0h2.4v4.164H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoorders);
export default __webpack_public_path__ + "static/media/Noorders.163d18dfc0d2f2f35827fa474a6d4f6c.svg";
export { ForwardRef as ReactComponent };